export type Faq = { question: string; answer: string };

export const homeFaqs: Faq[] = [
  {
    question: "What is the difference between a VPS and a dedicated server?",
    answer:
      "A VPS provides a virtual server environment with allocated resources, while a dedicated server provides server resources assigned to a single customer. The best option depends on workload, control and resource requirements.",
  },
  {
    question: "Which solution is suitable for a growing website?",
    answer:
      "A VPS can be a practical starting point for many growing websites. Websites with larger workloads or specialised requirements may benefit from cloud or dedicated infrastructure.",
  },
  {
    question: "Can I upgrade my server later?",
    answer:
      "Available upgrade paths depend on the selected product. Visitors should review the configuration options in the billing portal or contact the team for guidance.",
  },
  {
    question: "Does The Planet provide business email?",
    answer:
      "Yes. The business email solution includes a 30 GB mailbox and advanced features. The final billing term and complete feature list should appear in the WHMCS catalogue.",
  },
  {
    question: "How do I purchase a service?",
    answer:
      "Select a product on the website and click \u201cBuy Now\u201d or \u201cConfigure\u201d. The website will redirect you to the WHMCS-powered billing portal.",
  },
  {
    question: "Can I request a custom infrastructure setup?",
    answer:
      "Yes. Use the contact form to describe the workload, expected usage, preferred environment and security requirements.",
  },
  {
    question: "Where can I manage my services and invoices?",
    answer:
      "Customers can manage their services, invoices, payments and support requests through the WHMCS client area.",
  },
];
